import {RESET_REGISTER, SET_TOKEN_REGISTER, SET_FINISH_REGISTER} from '../../utils/constants/actionTypes'

const initialState = {
    token : '',
    isFinish : false
}

const registerState = (state = initialState, action) => {
    switch(action.type) {
        case RESET_REGISTER :
            return {
                token : "",
                isFinish : false
            }
        case SET_TOKEN_REGISTER :
            return {
                ...state,
                token : action.payload
            }
        case SET_FINISH_REGISTER :
            return {
                ...state,
                isFinish : true
            }
        default :
            return state;
    }
}

export default registerState;
    